/* Solid at rest: it used to fade to 60% until hovered, and a tablet has no hover */
.headerWrapper {
  position: relative;
  flex: 0 0 auto;
  background-color: var(--tuna-palette-background-paper);
  border-bottom: 1px solid var(--tuna-palette-divider);
}

/* One row at every desktop width. The part line gives way (it truncates); the controls never wrap */
.header {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
  min-height: 64px;
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  box-sizing: border-box;
}

.exit {
  flex-shrink: 0;
  white-space: nowrap;
  text-transform: none;
}

.titleBlock {
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  max-width: 22rem;
}

.eyebrow,
.title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.eyebrow {
  font-size: var(--tuna-typography-fontSize-xs);
  color: var(--tuna-content-secondary);
}

.title {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-2xl);
  font-weight: 600;
  line-height: 1.5rem;
}

/* The part line is text, not a control: the first thing to give way on a narrow screen */
.partLine {
  flex: 1 1 0;
  min-width: 0;
  margin-left: var(--tuna-spacing-1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--tuna-content-primary);
  font-variant-numeric: tabular-nums;
}

.rightSection {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: var(--tuna-spacing-0_5);
}

/* The part menu, Shapes | Concert, My notes and Display read in sentence case, like the song top bar
 * ("Playing Vocals + Guitar"), and each stays on one line: a two-line control in a one-line header reads as broken */
.rightSection button {
  text-transform: none;
  white-space: nowrap;
}

.structureMapSlot {
  display: flex;
  justify-content: center;
  padding: 0 var(--tuna-spacing-1);
}

.structureMapSlot:empty {
  display: none;
}

/* Phones: a 56px row (Exit ×, the title, My notes, Aa) over a 36px row for the part line and the part menu */
.compact .header {
  min-height: 56px;
  gap: var(--tuna-spacing-0_5);
  padding: 0 var(--tuna-spacing-0_5);
}

.compact .titleBlock {
  flex: 1 1 auto;
  max-width: none;
}

.compact .title {
  font-size: var(--tuna-typography-fontSize-xl);
  line-height: 1.375rem;
}

.compact button {
  min-width: 44px;
  min-height: 44px;
}

.partRow {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
  min-height: 36px;
  padding: 0 var(--tuna-spacing-1) 0 var(--tuna-spacing-2);
  border-top: 1px solid var(--tuna-border-subtle);
  font-size: var(--tuna-typography-fontSize-sm);
}

.partRow .partLine {
  margin-left: 0;
}

/* The row is 36px: its controls draw at 32px and take 44px of touch, the extra above and below */
.partRow button {
  position: relative;
  flex-shrink: 0;
  min-height: 32px;
  text-transform: none;
  white-space: nowrap;
}

.partRow button::after {
  content: '';
  position: absolute;
  inset: -6px 0;
}
